export default __webpack_public_path__ + "static/media/justmeasure_nitrat.b0a5c958.png";